import React from 'react';

const FreeQuote = () => {
  return (
    <div className="flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-4xl p-10">
      <h1
          className="text-6xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl 2xl:text-8xl font-bold text-black text-center mb-10"
        >
          Get Your Free Quote
        </h1>
        <form
          action="mailto:solarcareinternational@gmail.com"
          method="POST"
          encType="text/plain"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Left Column */}
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  required
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  required
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Address <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="address"
                  placeholder="Enter address"
                  required
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="+94 70 000 0000"
                  required
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                />
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Electricity Provider <span className="text-red-500">*</span>
                </label>
                <select
                  name="provider"
                  required
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                >
                  <option value="">Select Provider</option>
                  <option value="CEB">CEB</option>
                  <option value="LECO">LECO</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Phase <span className="text-red-500">*</span>
                </label>
                <select
                  name="phase"
                  required
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                >
                  <option value="">Select Phase</option>
                  <option value="Single Phase">Single Phase</option>
                  <option value="Three Phase">Three Phase</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  System Capacity <span className="text-red-500">*</span>
                </label>
                <select
                  name="capacity"
                  required
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                >
                  <option value="">Select Capacity</option>
                  <option value="2kw">2kw</option>
                  <option value="3kw">3kw</option>
                  <option value="5kw">5kw</option>
                  <option value="10kw">10kw</option>
                  <option value="15kw">15kw</option>
                  <option value="20kw and above">20kw and above</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Any Comments
                </label>
                <textarea
                  name="comments"
                  rows="4"
                  placeholder="Write your message..."
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
                ></textarea>
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="mt-10">
            <button
              type="submit"
              className="w-full py-3 rounded-full bg-gradient-to-r from-slate-800 to-slate-900 text-white text-lg font-semibold transition hover:scale-[1.02] hover:shadow-xl duration-200"
            >
              Submit Quote Request
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FreeQuote;